import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getObjCountForObjtype(params) {
    return axios.post(`${baseUrl}/virtual/performance/get-obj-count-for-objtype.do`, params);
  },
  /**
   * [성능/운영>리스트뷰] VMS 성능정보 조회
   * @author Song
   * @param  {Object} params
   * @return {Map}
   */
  getPerformanceCommonListview(params) {
    return axios.post(`${baseUrl}/virtual/performance/get-performance-common-listview.do`, params);
  },
  /**
   * [성능/운영>리스트뷰] VMS 그룹 성능정보, 리스트뷰 조회
   * @author Song
   * @param  {Object} params
   * @return {Map}
   */
  getVirtualGroupPerformanceInfo(params) {
    return axios.post(`${baseUrl}/virtual/performance/get-virtual-group-performance-info.do`, params);
  },
  /**
   * [성능/운영>리스트뷰] VMS 변경이력 조회
   * @author Song
   * @param  {Object} params
   * @return {Map}
   */
  compareVmsConfigHist(params) {
    return axios.post(`${baseUrl}/virtual/performance/compare-vms-config-hist.do`, params);
  },
  /**
   * [성능/운영>리스트뷰] VMS - VM 제어 (시작, 종료, 재시작, 일시정지)
   * @author Song
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}
   */
  executeVmContorl(params) {
    return axios.post(`${baseUrl}/virtual/performance/execute-vm-control.do`, params);
  },
  /**
   * VM 원격제어 - VM의 OS타입/IP 조회
   * @author kimjy
   * @param  {Integer} params objId
   * @return {Object}        osType, ipaddress
   */
  getVmTypeAndIPAddress(params) {
    return axios.get(`${baseUrl}/virtual/performance/get-vm-type-and-ipaddress.do`, { params });
  },
  /**
   * VM 스냅샷 리스트 조회
   * @author kimjy
   * @param  {Integer} objId
   */
  getVmsSnapshoDetailInfo(objId) {
    return axios.post(`${baseUrl}/virtual/performance/get-vms-snapshot-detail-info.do`, { objId });
  },
  /**
   * 스냅샷 실행
   * @author kimjy
   */
  executeVmSnapshot(params) {
    return axios.post(`${baseUrl}/virtual/performance/execute-vm-snapshot.do`, params);
  },
  /**
   * 햄버거버튼 - 마이그레이션 >선택한 VM에 연결된 호스트들의 성능정보 및 구성정보 리스트를 조회한다.
   * @author Song
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}
   */
  getVirtualMigrationList(params) {
    return axios.post(`${baseUrl}/virtual/performance/get-virtual-migration-list.do`, params);
  },
  /**
 * 마이그레이션 실행
 * @author kimjy
 */
  executeVmMigration(params) {
    return axios.post(`${baseUrl}/virtual/performance/execute-vm-migration.do`, params, { timeout: 500000 });
  },
  /**
 * VM명 중복 체크
 * @author kimjy
 */
  checkVmName(params) {
    return axios.post(`${baseUrl}/virtual/check-vm-name.do`, params);
  },
  /**
 * VM 변환/복제 수행
 * @author Song
 */
  executeVmConvert(params) {
    return axios.post(`${baseUrl}/virtual/performance/execute-vm-convert.do`, params);
  },
  /**
   * 등록 된 하이퍼바이저 종류에 따른 VM명 허용 정규식 조회
   * @author KangBonghun(toto1323)
   * @return {[type]}        [description]
   */
  getVmNameRegex() {
    return axios.get(`${baseUrl}/virtual/get-vm-name-regex.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/virtual/performance/common.js